<script setup lang="ts">
defineProps({
  image: { type: String || null, default: null },
  firstName: { type: String, required: true },
  lastName: { type: String, required: true }
})
</script>

<template>
  <div class="forum-avatar">
    <img v-if="image" class="forum-avatar-image" :src="image" >
    <div v-else class="forum-avatar-initials">
      <span>{{ `${firstName[0]}${lastName[0]}` }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.forum-avatar {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border: 1px solid var(--borderM2);
  overflow: hidden;

  &-image {
    height: 100%;
    width: 100%;
    margin: 0;
    display: block;
  }

  &-initials {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bgMedium);
    color: var(--textInitials);
    text-transform: uppercase;
    font-weight: 600;
    font-size: 1.5cqw;
  }
}
</style>
